import React, {useContext, useEffect, useState} from "react";
import {Box, Text, TextInput} from "grommet";
import {useDebounce} from "../../../utils/debounce";
import {handleErrors} from "../../../utils/errors";
import useSWR from "swr";
import {formatName} from "../../../utils/names";
import Badge from "../../Badge";
import { debounce } from "../../../utils/debounce";
import {
    faUserGroup as IconGroup
} from '@fortawesome/pro-light-svg-icons'
const SelectRecipient = ({
    onChange, defaultRecipient={}, onRecipientIsGroupChange, placeholder
}) => {
    const defaultLabel = defaultRecipient.company_name || formatName(defaultRecipient, true, '');
    const [keyword, setKeyword] = useState(defaultLabel || '');
    const [selected, setSelected] = useState();
    const [listSize, setListSize] = useState(5);
    const debouncedKeyword = useDebounce(keyword, 400);

    useEffect(() => {
        const defaultLabel = defaultRecipient.company_name || formatName(defaultRecipient, true, '');
        defaultLabel && setKeyword(defaultLabel);
    }, [defaultRecipient]);

    const fetcher = (args) => {
        return fetch(`${args[0]}?${args[1]}`)
            .then(handleErrors);
    }

    const { data: suggestedRecipients, error } = useSWR(
        // do not call customer endpoint initially
        (!selected || !keyword || (selected && selected.label !== keyword)) && (keyword !== defaultLabel) ?
            [`/api/customers`, new URLSearchParams({
                ...({
                    limit: listSize,
                    offset: 0,
                    exclude_groups: 1
                }),
                ...(debouncedKeyword && {keyword: debouncedKeyword.trim()}),
            }).toString()] :
            null,
        fetcher
    );

    const renderSuggestions = () => {
        if (!suggestedRecipients || !suggestedRecipients?.customers || !keyword || (selected && selected?.textLabel && selected.textLabel === keyword)) return [];
        return suggestedRecipients.customers
            .map(({company_name, id, number_of_customers, ...rest}) => ({
                label: (
                    <Box direction="row" align="center" gap="small" pad={{vertical: 'small', horizontal: 'small'}}>
                        <Text>{company_name || formatName(rest, true)}</Text>
                        {!!number_of_customers && (<Badge icon={IconGroup}>
                            Group
                        </Badge>)}
                    </Box>
                ),
                textLabel: company_name || formatName(rest, true),
                value: id,
                isGroup: !!number_of_customers
            }))
            .filter(recipient => !!recipient.label)
            .sort(({label: a}, {label: b}) => {
                if (a === b) return 0;
                if (a > b) return -1;
                if (a < b) return 1;
            });
    };

    const onSuggestionSelect = event => {
        setSelected(event.suggestion);
        setKeyword(event.suggestion.textLabel);
        onChange({value: event.suggestion.value});
        onRecipientIsGroupChange && onRecipientIsGroupChange(event.suggestion.isGroup);
    }

    const onChangeHandler = event => {
        setKeyword(event.target.value);
        onChange({value: ''});
    }

    return (
        <TextInput
            type="search"
            placeholder={placeholder || "Ex: Acme Inc."}
            value={keyword || ''}
            onChange={onChangeHandler}
            onSuggestionSelect={debounce(onSuggestionSelect, 300)}
            suggestions={renderSuggestions()}
            plain
        />
    )
};

export default SelectRecipient;
